import React from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import theme from '../styles/theme'
import Img from 'gatsby-image'
require('slick-carousel/slick/slick.css')
require('slick-carousel/slick/slick-theme.css')

const WrapperInfluencer = styled.section`
  // float: left;
`

const Influencer = styled.li`
  background: ${props => props.theme.colors.white};
  position: relative;
  width: 98%;
  transition: background 0.2s;
  margin: 0 0 150px 0;

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    flex: ${props => (props.featured ? '0 0 100%' : '0 0 49%')};
  }
  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    flex: ${props => (props.featured ? '0 0 100%' : '0 0 32%')};
  }

  @media screen and (max-width: ${props => props.theme.responsive.medium}) {
    margin: 0 auto 30px auto;
  }

  &:hover {
    background: ${props => props.theme.colors.white};
  }
  a {
    display: flex;
    flex-flow: column;
    height: 100%;
    width: 100%;
    color: ${props => props.theme.colors.base};
    text-decoration: none;
    .gatsby-image-wrapper {
      height: 0;
      padding-bottom: 60%;
      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        padding-bottom: ${props => (props.featured ? '40%' : '60%')};
      }
    }
  }

  .showme {
    display: none;
    background: green;
  }
  @media only screen and (max-width: ${props => props.theme.responsive.large}) {
    .showme { 
      display: block;
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    .showhim:hover .showme {
      // display: block;
    }
    .showhim:hover .ok {
      // display: none;
    }
  }

  .circle-image {
    padding: 1em 4rem;
  }
`

const Name = styled.h2`
  margin: auto;
  width: auto;
  margin-top: 1em;
  font-family: Cormorant;
  font-size: 22px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0.727273px;
  text-align: center;
  color: ${props => props.theme.colors.black};
  font-weight: 500;
`

const BgImg = styled(Img)`
  height: auto;
  border-radius: 50%;
  div {
    width: 100%;
    height: 100%;
    border-radius: 50% !important;
    padding-bottom: 100% !important;
  }
  picture img {
    border-radius: 50% !important;
  }
`

const HoverContent = styled.div`
  height: 100%;
  background: blue; 

  padding: 1em;
  font-family: Cormorant;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  text-align: center;
  color: ${props => props.theme.colors.black};
`
const HoverContentTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.1px;
`




const HoverContentDivider = styled.div`
  margin: 0 auto;
  margin-top: 2em;
  width: 110px;
  height: 2px;
  border: solid 1.5px #090c30;
`

const Headline = styled.h3`
  font-family: Raleway;
  font-size: 18px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.4px;
  text-align: center;
  color: ${props => props.theme.colors.black};
`

const Wrapper = styled.section`
  margin-top: 3em;
  padding-bottom: 0;
  @media screen and (max-width: ${props => props.theme.responsive.medium}) {
    padding-bottom: 5em;
  }
`

const HomeInfluencers = props => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    rows: 5,
    slidesPerRow: 3,
    arrows: false,
    dotsClass: 'slick-dots-new',
    responsive: [
      {
        breakpoint: theme.breakpoint.medium,
        settings: {
          slidesPerRow: 1,
          rows: 1,
          centerMode: true,
          centerPadding: '10px',
        },
      },
    ],
  }

  return (
    <Wrapper>
      <Slider {...settings}>


      {(props.team).map(({ node: inf }, index) => (
        <WrapperInfluencer key={`memberIndex${index}`}>
          <Influencer key={inf.id} featured={inf.featured}>
            <div className="showhim">
              <div className="circle-image">
                <BgImg className="ok" fluid={inf.heroImage.fluid} />
              </div>
              <Name>{inf.name}</Name>
              <Headline>{inf.title}</Headline>
              {/* <HoverContent className="showme">
                <HoverContentTitle>{inf.descriptionTitle}</HoverContentTitle>
                <div
                dangerouslySetInnerHTML={{ __html: inf.description.childMarkdownRemark.html }}
                />
              </HoverContent> */}
            </div>
        </Influencer>
        </WrapperInfluencer>
      ))}


      
      
      {props.children}
      </Slider>
    </Wrapper>
  )
}

export default HomeInfluencers
